import {
  createSelectorHooks,
  ZustandHookSelectors
} from 'auto-zustand-selectors-hook'
import create from 'zustand'

interface AttachFilesState {
  orderId: string | null
  proposalId: string | null
  isModalOpen: boolean
  setModalOpen: (open: boolean) => void
  setOrderId: (orderId: string | null) => void
  setProposalId: (proposalId: string | null) => void
  reset: () => void
}

const useStoreBase = create<AttachFilesState>()((set) => ({
  orderId: null,
  proposalId: null,
  isModalOpen: false,
  setModalOpen: (isModalOpen: boolean) => set(() => ({ isModalOpen })),
  setOrderId: (orderId: string | null) => set(() => ({ orderId })),
  setProposalId: (proposalId: string | null) => set(() => ({ proposalId })),
  reset: () =>
    set(() => ({
      orderId: null,
      proposalId: null,
      isModalOpen: false
    }))
}))

export const useAttachFilesStore = createSelectorHooks(
  useStoreBase
) as typeof useStoreBase & ZustandHookSelectors<AttachFilesState>
